import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { AlertService } from '@app/shared/services/alert.service';
import { MatTooltipModule } from '@angular/material/tooltip';

@Injectable({ providedIn: 'root' })
export class ConfirmationDialogService {
  constructor(private alertService: AlertService) { }

  showReleaseConfirmation(envServiceMap: { [env: string]: string }, Page: string, InfoForService: any): Promise<boolean> {
    const envKeys = Object.keys(envServiceMap);
    let tableHtml = `
    <div>
      <b class="text-muted" style="font-size: 20px; display: block; margin-bottom: 16px;">
        Are you sure you want to create the ${Page} based on the applicable services for each environment?
      </b>
      <div style="max-height: 300px; overflow-y: auto; overflow-x: hidden;">
        <table style="border-collapse:collapse; table-layout:auto; width:100%;" class="table table-bordered table-sm">
          <thead>
            <tr>
              <th style="border:1px solid #ddd;padding:8px; word-break:break-word; width:160px;">Environment</th>
              <th style="border:1px solid #ddd;padding:8px; word-break:break-word; width:590px;">Services</th>
            </tr>
          </thead>
          <tbody>
            ${envKeys.map(env => `
              <tr>
                <td style="border:1px solid #ddd;padding:8px; word-break:break-word;">${env}</td>
                <td style="border:1px solid #ddd;padding:8px; word-break:break-word; text-justify:inter-word;">
                  ${envServiceMap[env]
                    .split(',')
                    .map(service => service.trim())
                    .filter(service => service)
                    .map(service => {
                      if (InfoForService && InfoForService[service]) {
                        return `
                          <span class="info-icon">
                            ${service}
                            <span class="info-icon-info">
                              <i class="mr-0 fs-18 material-icons material-icons-info" aria-hidden="true">info</i>
                              <span class="info-tooltip tooltip-left">${InfoForService[service]}</span>
                            </span>
                          </span>
                        `;
                      } else {
                        return service;
                      }
                    })
                    .join(', <wbr>')}
                </td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        
      </div>
      <style>
        .info-icon {
          position: relative;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 4px;
        }
        .info-icon-info {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .material-icons,
        .material-icons-info {
          vertical-align: middle;
          font-size: 18px;
          line-height: 1;
        }
        .info-tooltip {
          visibility: hidden;
          opacity: 0;
          width: max-content;
          max-width: 250px;
          background: white;
          color: black;
          text-align: left;
          border-radius: 4px;
          padding: 8px 12px;
          position: absolute;
          z-index: 10;
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
          margin-left: 8px;
          box-shadow: 0px 0px 6px 3px rgba(0, 0, 0, 0.25);
          font-size: 13px;
          transition: opacity 0.2s;
          pointer-events: none;
          white-space: pre-line;
        }
        .info-icon-info:hover .info-tooltip {
          visibility: visible;
          opacity: 1;
        }
        .info-tooltip.tooltip-left {
          left: auto;
          right: 100%;
          margin-left: 0;
          margin-right: 8px;
        }
        .table, .table th, .table td {
          word-break: break-word !important;
          white-space: normal !important;
          border: 1px solid #ddd;
          padding: 8px;
        }
        td[style*="text-align:justify"] {
          text-align: justify !important;
          text-justify: inter-word !important;
        }
      </style>
    </div>
    `;

    // Use AlertService for InfoIcon and button CSS
    const swalInstance = this.alertService.buildDialogCustomIcon(this.alertService.InfoIcon);

    return swalInstance.fire({
      title: '',
      html: tableHtml,
      icon: this.alertService.WarningIcon,
      showCancelButton: true,
      confirmButtonText: 'OK',
      cancelButtonText: 'Cancel',
      width: 800,
    }).then(result => result.isConfirmed);
  }
}